// MarketPlace.jsx - فایل اصلی
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Redirect } from 'react-router-dom';
import SimpleReactLightbox from 'simple-react-lightbox';

import { set_me } from '../../actions/user';
import { getBasket, remove_product_basket } from '../../actions/cartActions';
import { ROUTES } from '../profileInfo/constant/Routes';
import AppBar from '../AppBar';
import Footer from '../Footer';
import Loader from '../Loader';
import HeadMeta from '../../helmet/HeadMeta/HeadMeta';
import CartContainer from './components/CartContainer';
import EmptyCart from './components/EmptyCart';
import ErrorModal from './components/ErrorModal';
import useMarketPlace from './hooks/useMarketPlace';
import './MarketPlace.css';
import useResponsive from './hooks/useResponsive';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useOrders from '../profileInfo/Forms/ordersList/hooks/useOrders';
import { conf, dates } from '../../confg';
import { ResponsiveModal } from '../profileInfo/components/logout/ResponsiveModal';

const MarketPlace = (props) => {
  const { isMobile } = useResponsive();
  const [showPendingOrderModal, setShowPendingOrderModal] = useState(false);

  const { orders: currentOrders, getOrdersByStatusFromServer } = useOrders({
    server_url: conf.server_url,
    image_url: conf.base_url,
    user: props.user,
    dates: dates,
  });

  useEffect(() => {
    getOrdersByStatusFromServer('pending', 1);
  }, []);

  // فیلتر کردن سفارشات pending و پیدا کردن اولین یکی
  const getLatestPendingOrder = () => {
    console.log({ currentOrders });
    const pendingOrders = currentOrders.filter((order) => order.status === 'pending');

    if (pendingOrders.length === 0) return null;

    // اولین آیتم pending رو برگردون
    return pendingOrders[0];
  };

  const latestPendingOrder = getLatestPendingOrder();
  const history = useHistory();
  console.log('latestPendingOrder', latestPendingOrder);

  // نمایش مدال اگر سفارش pending داریم
  useEffect(() => {
    if (latestPendingOrder) {
      setShowPendingOrderModal(true);
    }
  }, [latestPendingOrder]);

  const handleGoToPayment = () => {
    setShowPendingOrderModal(false);
    window.location = `${conf.base_url}payment/${latestPendingOrder?.orders_id}`;
  };

  const handleContinueShopping = () => {
    setShowPendingOrderModal(false);
  };

  const {
    displayProducts,
    showLoader,
    currentView,
    setCurrentView,
    showErrorModal,
    setShowErrorModal,
    deleteFromCart,
    deleteThisProductId,
    totals,
    totalForNotLogginUser,
    cart_items,
    goToStore,
    redirectToShippingPage,
    defaultAddress,
    handleNext,
    handleBackToStore,
  } = useMarketPlace(props);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle redirects
  if (goToStore) {
    return <Redirect to='/store' />;
  }

  if (redirectToShippingPage) {
    if (Object.keys(props?.user).length == 0) {
      history.push({
        pathname: `${ROUTES.SIGN_IN}`,
        search: '?fromBasket=true',
        state: { referrer: '/addressPage' },
      });
      return null;
    } else {
      return (
        <Redirect
          push={true}
          to={{
            pathname: ROUTES.SHIPPING,
            state: { referrer: '/addressPage' },
          }}
        />
      );
    }
  }

  return (
    <SimpleReactLightbox>
      <div className='wrapper'>
        <HeadMeta tabTitle='سبد خرید' />

        <div className='marketplace-appbar-wrapper'>
          <AppBar />
        </div>

        <div className='marketplace-page-container'>
          <div className='marketplace-page-wrapper'>
            {/* نمایش Loader */}
            {showLoader && (
              <div className='loading-container'>
                <Loader />
              </div>
            )}

            {/* نمایش محتوا */}
            {!showLoader && (
              <>
                {displayProducts && displayProducts.length > 0 ? (
                  <CartContainer
                    displayProducts={displayProducts}
                    user={props.user}
                    gold={props.gold}
                    translate={props.translate}
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                    deleteFromCart={deleteFromCart}
                    deleteThisProductId={deleteThisProductId}
                    cart_items={cart_items}
                    cart_credit={props.cart_credit}
                    totals={totals}
                    totalForNotLogginUser={totalForNotLogginUser}
                    onNext={handleNext}
                    onBackToStore={handleBackToStore}
                  />
                ) : (
                  <EmptyCart translate={props.translate} />
                )}
              </>
            )}
          </div>
        </div>

        <ErrorModal show={showErrorModal} onHide={() => setShowErrorModal(false)} message={props.location?.state?.modalMessage} />

        {/* مدال سفارش در انتظار پرداخت */}
        <ResponsiveModal
          isOpen={showPendingOrderModal}
          onClose={handleContinueShopping}
          title='سفارش در انتظار پرداخت'
          primaryButtonText='ادامه پرداخت'
          secondaryButtonText='ادامه خرید'
          onPrimaryClick={handleGoToPayment}
          onSecondaryClick={handleContinueShopping}
          showCloseButton={true}
        >
          {latestPendingOrder && (
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              {/* تصاویر محصولات */}
              <div
                style={{
                  marginBottom: '15px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  flexWrap: 'wrap',
                }}
              >
                {latestPendingOrder.all_product_images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`محصول ${index + 1}`}
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #e2e8f0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  />
                ))}
              </div>

              {/* اطلاعات سفارش */}
              <div style={{ marginBottom: '15px' }}>
                <p
                  style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    color: '#1a202c',
                    margin: '0 0 8px 0',
                  }}
                >
                  شماره سفارش: {latestPendingOrder.tracking_code}
                </p>

                <p
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#01494b',
                    margin: '0 0 8px 0',
                  }}
                >
                  مبلغ: {latestPendingOrder.order_price} تومان
                </p>

                <p
                  style={{
                    fontSize: '12px',
                    color: '#718096',
                    margin: '0 0 15px 0',
                  }}
                >
                  تاریخ: {latestPendingOrder.fa_date_purchased} - {latestPendingOrder.ago}
                </p>
              </div>

              {/* پیام اصلی */}
              <div
                style={{
                  backgroundColor: 'rgb(232, 249, 239)',
                  border: '1px solid #fed7d7',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '15px',
                }}
              >
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    color: '#2d3748',
                    margin: '0 0 8px 0',
                    lineHeight: '1.6',
                  }}
                >
                  شما یک سفارش در انتظار پرداخت دارید
                </p>

                <p
                  style={{
                    fontSize: '12px',
                    color: '#4a5568',
                    margin: '0',
                    lineHeight: '1.5',
                  }}
                >
                  می‌توانید پرداخت این سفارش را تکمیل کنید یا خرید جدیدتان را ادامه دهید
                </p>
              </div>

              {/* آمار محصولات */}
              {latestPendingOrder.total_images_count > 1 && (
                <p
                  style={{
                    fontSize: '11px',
                    color: '#a0aec0',
                    margin: '0',
                  }}
                >
                  شامل {latestPendingOrder.total_images_count} محصول
                </p>
              )}
            </div>
          )}
        </ResponsiveModal>

        <Footer />

        <style jsx>{`
          .loading-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            min-height: 60vh;
            gap: 20px;
            padding: 40px 20px;
          }

          .loading-text {
            color: #6b7280;
            font-size: 16px;
            font-weight: 500;
            margin: 0;
            text-align: center;
            direction: rtl;
          }

          @media (max-width: 768px) {
            .loading-container {
              min-height: 50vh;
              padding: 30px 15px;
            }

            .loading-text {
              font-size: 14px;
            }
          }
        `}</style>
      </div>
    </SimpleReactLightbox>
  );
};

const mapStateToProps = (state) => ({
  translate: getTranslate(state.localize),
  user: state.user,
  gold: state.gold_price,
  cart: state.cart.cart,
  cart_report: state.cart.cart_report,
  cart_update: state.cart.cart_update,
  cart_credit: state.cart.cart_credit,
  credit: state.cart.cart_credit,
  order_address: state.cart.order_address,
  order_shipping: state.cart.order_shipping,
  price_shipping: state.cart.price_shipping,
  time_index: state.cart.time_index,
  total_discount: state.cart.cart_report.total_discount,
  total_price: state.cart.cart_report.total_price,
  total_weight_to_pay: state.cart.cart_costs.total_weight_to_pay,
  total_gr: state.cart.cart_report.total_gr,
  date: state.cart.date,
  deposit_price: state.deposit_price,
  pay_type: state.pay_type,
  discount: state.discount,
  discountCode: state.discountCode,
});

const mapDispatchToProps = {
  remove_product_basket,
  set_me,
  getBasket,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketPlace);
